import ListingFilterDefinition, {
  ListingFilterDefinitionOption,
  ListingFilterDefinitionOptionBadgeData,
  ListingFilterDefinitionOptionSelectData,
  ListingFilterDefinitionOptionSelectDataType,
} from "../../../../../common/components/listing/filter/types/listing-filter-definition";
import orderOptimizerTranslationsHelper from "../../../../../languages/order-optimizer-translations.helper";
import OrderOptimizerCargoListingFilter, {
  OrderOptimizerCargoListingOrderHumanIdFilter,
} from "../common/types/order-optimizer-cargo-listing-filter";
import OrderOptimizerCargoListingFilterType from "../common/types/order-optimizer-cargo-listing-filter-type";

const orderOptimizerCargoListingFiltersHelper = () => {
  const translations =
    orderOptimizerTranslationsHelper.getCargoListingTranslations();

  const createBadgeData = (
    value: string,
    textTemplate: string,
    titleTemplate: string,
  ): ListingFilterDefinitionOptionBadgeData => {
    return {
      text: textTemplate.replace("#{query}", value),
      title: titleTemplate.replace("#{query}", value),
    };
  };

  const getSelectDataForOrderHumanId = (
    query: string,
  ): ListingFilterDefinitionOptionSelectData => {
    return {
      type: ListingFilterDefinitionOptionSelectDataType.NUMERIC_QUERY,
      options: [
        {
          label: translations.filters.search.orderHumanIdTemplateLabel.replace(
            "#{query}",
            query,
          ),
          value: Number.parseInt(query),
        },
      ],
    };
  };

  const getSelectDataByType = (
    filterType: OrderOptimizerCargoListingFilterType,
    query: string,
  ) => {
    const options: Record<
      OrderOptimizerCargoListingFilterType,
      (query: string) => ListingFilterDefinitionOptionSelectData
    > = {
      [OrderOptimizerCargoListingFilterType.ORDER_HUMAN_ID]:
        getSelectDataForOrderHumanId,
    };

    const result = options[filterType](query);

    return result;
  };

  const getBadgeForOrderHumanId = (
    filterValue: OrderOptimizerCargoListingOrderHumanIdFilter["value"],
  ): ListingFilterDefinitionOptionBadgeData => {
    return createBadgeData(
      String(filterValue),
      translations.filters.orderHumanIdLabel,
      translations.filters.orderHumanIdTitle,
    );
  };

  const getBadgeDefinitionByType = (
    filterType: OrderOptimizerCargoListingFilterType,
    filterValue: OrderOptimizerCargoListingFilter["value"],
  ): ListingFilterDefinitionOptionBadgeData => {
    const options: Record<
      OrderOptimizerCargoListingFilterType,
      (
        filterValue: OrderOptimizerCargoListingFilter["value"],
      ) => ListingFilterDefinitionOptionBadgeData
    > = {
      [OrderOptimizerCargoListingFilterType.ORDER_HUMAN_ID]:
        getBadgeForOrderHumanId,
    };

    return options[filterType](filterValue);
  };

  const getFilterDefinitionByType = (
    filterType: OrderOptimizerCargoListingFilterType,
  ): ListingFilterDefinitionOption<OrderOptimizerCargoListingFilter> => {
    return {
      getSelectData: (query) => getSelectDataByType(filterType, query),
      getBadgeData: (value) => getBadgeDefinitionByType(filterType, value),
      filterType,
    };
  };

  const getFilterDefinitionOptions =
    (): ListingFilterDefinitionOption<OrderOptimizerCargoListingFilter>[] => {
      return Object.values(OrderOptimizerCargoListingFilterType).map(
        getFilterDefinitionByType,
      );
    };

  const getFilterDefinition =
    (): ListingFilterDefinition<OrderOptimizerCargoListingFilter> => {
      return {
        options: getFilterDefinitionOptions(),
      };
    };

  return {
    getFilterDefinition,
  };
};

export default orderOptimizerCargoListingFiltersHelper;
